import makerCheckerServices from '@/services/makerCheckerServices';

const normalizeListResponse = (axiosResponse) => {
  const body = axiosResponse?.data;
  const items = Array.isArray(body) ? body : body?.data ?? [];
  const pagination = body?.pagination;

  return {
    data: items,
    pagination: pagination ?? {
      page: 1,
      pageSize: items.length,
      total: items.length,
    },
  };
};

export default {
  namespaced: true,
  state: {
    pendingChecks: [],
    requestedChecks: [],
    pagination: {
      page: 1,
      pageSize: 30,
      total: 0
    }
  },
  mutations: {
    SET_PENDING_CHECKS(state, { data, pagination }) {
      state.pendingChecks = data;
      if (pagination) {
        state.pagination = pagination;
      }
    },
    SET_REQUESTED_CHECKS(state, { data, pagination }) {
      state.requestedChecks = data;
      if (pagination) {
        state.pagination = pagination;
      }
    }
  },
  actions: {
    async getPendingChecks({ commit }, params) {
      try {
        const response = await makerCheckerServices.getPendingChecks(params);
        const normalized = normalizeListResponse(response);
        commit('SET_PENDING_CHECKS', normalized);
        return normalized;
      } catch (error) {
        throw error;
      }
    },

    async getRequestedChecks({ commit }, params) {
      try {
        const response = await makerCheckerServices.getRequestedChecks(params);
        const normalized = normalizeListResponse(response);
        commit('SET_REQUESTED_CHECKS', normalized);
        return normalized;
      } catch (error) {
        throw error;
      }
    },

    async getCheckDetails(_, id) {
      try {
        const response = await makerCheckerServices.getCheckDetails(id);
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    async getCheckItemDetails(_, { itemType, itemId }) {
      try {
        const response = await makerCheckerServices.getCheckItemDetails({ itemType, itemId });
        return response.data;
      } catch (error) {
        throw error;
      }
    },

    async updateCheckStatus({dispatch}, { id, status, comments }) {
      try {
        const response = await makerCheckerServices.updateCheckStatus(id, status, comments);
        const successMessage = status === 'Approve' ? 'Request approved successfully' : 'Request rejected successfully';
        dispatch(
          'notifications/displayNotification',
          { message: successMessage, type: 'success' },
          { root: true }
        );
        return response.data;
      } catch (error) {
        const { message, statusText } = error;
        dispatch(
          'notifications/displayNotification',
          { message: message ? message : statusText, type: 'danger' },
          { root: true }
        );
        throw error;
      }
    }
  }
}; 